module.exports = __webpack_public_path__ + "static/OAuth Flow-7a42eee07a0481e2cfe590e924df53d7.svg";